import React, { useEffect, useRef, useState } from 'react';
import activeDropdown from './ActiveLink/activeDropdown';
import ActiveLink from './ActiveLink/ActiveLink';
import styles from './header.module.scss';
import HeaderArrow from './icons/HeaderArrow';
import { useRouter } from 'next/router';

type HeaderProps = {
    setBackground: Function;
};

const MobileHeaderComponent = ({ setBackground: setBackgroundColor }: HeaderProps) => {
    const router = useRouter();
    const [menuOpen, setMenuOpen] = useState(false);
    const [offeringsOpen, setOfferingsOpen] = useState(false);
    const [servicesOpen, setServicesOpen] = useState(false);
    const [aboutUsOpen, setAboutUsOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        document.body.style.overflowY = menuOpen ? 'hidden' : 'scroll';
        setBackgroundColor(!menuOpen ? styles.noBgNoFade : styles.bgNoFade);
    }, [menuOpen]);

    // Close the menu when the user taps/clicks anywhere outside the menu and the hamburger button
    useEffect(() => {
        if (!menuOpen) return;

        const onPointerDownOutside = (event: MouseEvent | TouchEvent) => {
            const target = event.target as Node;
            if (menuRef.current?.contains(target) || buttonRef.current?.contains(target)) return;
            setMenuOpen(false);
        };

        document.addEventListener('mousedown', onPointerDownOutside);
        document.addEventListener('touchstart', onPointerDownOutside);
        return () => {
            document.removeEventListener('mousedown', onPointerDownOutside);
            document.removeEventListener('touchstart', onPointerDownOutside);
        };
    }, [menuOpen]);

    const onClick = () => setMenuOpen(!menuOpen);
    const onOfferingsClick = () => setOfferingsOpen(!offeringsOpen);
    const onServicesClick = () => setServicesOpen(!servicesOpen);
    const onAboutUsClick = () => setAboutUsOpen(!aboutUsOpen);

    const goToContactUsClick = () => router.push('/contact');

    return (
        <>
            <button
                ref={buttonRef}
                onClick={onClick}
                aria-label="Open the navigation menu"
                className={`${styles.hamburgerButton} ${
                    menuOpen ? styles.hamburgerButtonOpen : ''
                }`}
            >
                <span></span>
                <span></span>
            </button>
            <div
                ref={menuRef}
                className={`${styles.hamburgerMenu} ${menuOpen ? styles.hamburgerMenuOpen : ''}`}
                aria-label="Navigation menu"
            >
                <button className={styles.navElement} onClick={onOfferingsClick}>
                    <span
                        className={`${styles.navElementDropdown} ${
                            offeringsOpen ? styles.navElementDropdownOpen : ''
                        } ${activeDropdown() === 'solutions' ? styles.active : ''}`}
                    >
                        Products
                        <HeaderArrow />
                    </span>
                </button>
                <div
                    className={`${styles.navElementSubmenu} ${
                        offeringsOpen ? styles.navElementSubmenuOpen : ''
                    }`}
                >
                    <div className={styles.navElementSubmenuItems}>
                        <ActiveLink href="/insurance-platform">
                            <span>Noria Insurance Platform</span>
                        </ActiveLink>
                    </div>
                </div>

                <button className={styles.navElement} onClick={onServicesClick}>
                    <span
                        className={`${styles.navElementDropdown} ${
                            servicesOpen ? styles.navElementDropdownOpen : ''
                        } ${activeDropdown() === 'services' ? styles.active : ''}`}
                    >
                        Services
                        <HeaderArrow />
                    </span>
                </button>

                <div
                    className={`${styles.navElementSubmenu} ${
                        servicesOpen ? styles.navElementSubmenuOpen : ''
                    }`}
                >
                    <div className={styles.navElementSubmenuItems}>
                        <ActiveLink href="/services/digital-strategy">
                            <span>Digital Strategy</span>
                        </ActiveLink>
                        <ActiveLink href="/services/transformation-delivery">
                            <span>Transformation Delivery</span>
                        </ActiveLink>
                        <ActiveLink href="/services/software-engineering-and-solution-architecture">
                            <span>
                                Software Engineering &<br /> Solution Architecture
                            </span>
                        </ActiveLink>
                        <ActiveLink href="/services/insights-and-analytics">
                            <span>Insights & Analytics</span>
                        </ActiveLink>
                        <ActiveLink href="/services/quality-assurance-and-test-engineering">
                            <span>
                                Quality Assurance &<br /> Test Engineering
                            </span>
                        </ActiveLink>
                        <ActiveLink href="/services/cloud-and-devops">
                            <span>Cloud & Devops</span>
                        </ActiveLink>
                        <ActiveLink href="/services/cloud-operations">
                            <span>Cloud Operations</span>
                        </ActiveLink>
                    </div>
                </div>
                <ActiveLink className={styles.navElement} href="/resources">
                    <span>Insights</span>
                </ActiveLink>
                <button className={styles.navElement} onClick={onAboutUsClick}>
                    <span
                        className={`${styles.navElementDropdown} ${
                            aboutUsOpen ? styles.navElementDropdownOpen : ''
                        } ${activeDropdown() === 'about-us' ? styles.active : ''}`}
                    >
                        About
                        <HeaderArrow />
                    </span>
                </button>
                <div
                    className={`${styles.navElementSubmenu} ${
                        aboutUsOpen ? styles.navElementSubmenuOpen : ''
                    }`}
                >
                    <div className={styles.navElementSubmenuItems}>
                        <ActiveLink href="/about-us">
                            <span>About Noria</span>
                        </ActiveLink>
                        <ActiveLink href="/about-us/management-team">
                            <span>Management team</span>
                        </ActiveLink>
                        <a href="https://career.noria.no" target="_blank">
                            Join us
                        </a>
                    </div>
                </div>
                <button className="nv-buton nv-button-primary" onClick={goToContactUsClick}>
                    Talk to our team ➔
                </button>
            </div>
        </>
    );
};

export default MobileHeaderComponent;
